import { UserInformationAbsencesResponse, UserInformationAbsencesResponseItem } from '@/types/service-response'

export class CurrentUserAbsence {
  private constructor (
    readonly categoryID: number,
    readonly categoryName: string,
    readonly totalDuration: number,
    readonly absences: Array<{
      readonly dateDuration: string,
      readonly duration: number,
      readonly note: string
      readonly ID: number,
      readonly employeeId: number
    }>
  ) {}

  public static createListFromResponse (data: UserInformationAbsencesResponse): Array<CurrentUserAbsence> {
    const result: Array<CurrentUserAbsence> = []

    data.forEach((item: UserInformationAbsencesResponseItem) => {
      if (!result.some((a: CurrentUserAbsence) => a.categoryID === item.Grund)) {
        const filtered = data.filter((b: UserInformationAbsencesResponseItem) => b.Grund === item.Grund)
        const absences = filtered.map((c: UserInformationAbsencesResponseItem) => {
          return {
            dateDuration: c.VonBis,
            duration: c.Tage,
            note:  c.Bemerkung || '',
            ID: c.ID,
            employeeId: c.MitarbeiterId
          }
        })
        const totalDuration = absences.reduce((sum, { duration }) => sum + duration, 0)
        result.push(new CurrentUserAbsence(
          item.Grund,
          item.GrundDescription,
          totalDuration,
          absences
        ))
      }
    })

    return result
  }
}

